<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.pages.name') }}</h2>
                        <p class="card-description">{{ $t('names.pages.description') }}</p>
                        <b-button variant="primary" class="mt-4 mb-4" @click="$router.push('/page/new')">{{ $t('createNewTitle') }}</b-button>
                        <b-table striped hover :items="pages" :fields="fields" @row-clicked="editPage" class="clickable"></b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../config'

    export default {
        name: 'PageList',
        data() {
            return {
                pages: [],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true,
                        thStyle: 'width: 75px;'
                    },
                    {
                        key: 'name',
                        label: this.$t('forms.name'),
                        sortable: true
                    },
                    {
                        key: 'url',
                        label: 'URL',
                        sortable: false
                    }
                ]
            }
        },
        mounted() {
            axios.get(Const.API_HOST + '/admin/pages')
                .then(response => response.data).then(body => {
                this.pages = body
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error)
            })
        },
        methods: {
            editPage(item) {
                this.$router.push('/page/edit/' + item.id)
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

</style>
